var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.48 4.48l-5.44 4.8H1.92v6.08h5.12l5.44 4.8V4.48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.578 12.16l-2.666-3.2 1.536-1.28 2.432 2.918 2.432-2.918 1.536 1.28-2.666 3.2 2.666 3.2-1.536 1.28-2.432-2.918-2.432 2.918-1.536-1.28 2.666-3.2z"
  })));
}
export default SvgMuted;